"use client";

import { useContext } from "react";
import { useEditDialog } from "../Providers/EditDialogContext";
import { CampaignType } from "@/interfaces/campaign";
import { FilterParamsContext } from "@/stories/SearchDrawerComponents/FilterParamsProvider";
import ProximityField from "@/stories/SearchDrawerComponents/ProximityField";
import TextFieldWithChips from "@/stories/SearchDrawerComponents/TextFieldWithChips";

export default function SearchFields() {
  const { filterParams } = useContext(FilterParamsContext);
  const {
    campaignType,
    searchTerms,
    setSearchTerms,
    mustIncludeTerms,
    setMustIncludeTerms,
    proximity,
    setProximity,
  } = useEditDialog();

  // Default to video if campaign type is not available
  const isVideoCampaign = campaignType
    ? campaignType === CampaignType.Video
    : true; // Default to true while loading

  const encodedFilterParams = btoa(JSON.stringify(filterParams));

  return (
    <>
      <TextFieldWithChips
        terms={searchTerms}
        setTerms={setSearchTerms}
        encodedFilterParams={encodedFilterParams}
        name="search-terms"
        placeholder="Key Terms (e.g., cloud services, HVAC system, cybersecurity)"
        label="Show me meetings that mention..."
        showCountBadge={isVideoCampaign}
        showAddButton={true}
      />
      {isVideoCampaign && (
        <>
          <TextFieldWithChips
            terms={mustIncludeTerms}
            setTerms={setMustIncludeTerms}
            encodedFilterParams={encodedFilterParams}
            name="must-include-terms"
            placeholder="Included Anchor Terms (e.g., contract, RFP, vendor selection)"
            label="While also mentioning..."
            showCountBadge={false}
            className="pl-4"
          />
          <ProximityField
            proximity={proximity}
            setProximity={setProximity}
            className="pl-4"
          />
        </>
      )}
    </>
  );
}
